export interface LookAngles {
  pitchRad: number;
  yawRad: number;
}

interface Vec3Like {
  x: number;
  y: number;
  z: number;
}

function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export function lookAnglesFromForward(forward: Vec3Like): LookAngles {
  const len = Math.hypot(forward.x, forward.y, forward.z);
  if (!Number.isFinite(len) || len < 1e-8) {
    return { pitchRad: 0, yawRad: 0 };
  }

  const x = forward.x / len;
  const y = forward.y / len;
  const z = forward.z / len;
  return {
    pitchRad: Math.asin(clamp(y, -1, 1)),
    yawRad: Math.atan2(-x, -z),
  };
}
